import _debounce from 'lodash.debounce';

export const sleep = (ms: number) =>
	new Promise(resolve => setTimeout(resolve, ms));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debounce = (callback: (...args: any) => any, wait?: number) =>
	_debounce(callback, wait);
